import { TFunction } from 'i18next'

import { CompanyCountryId } from '@features/invoices/types/companyCountryId'
import { isCompanyCountryId } from '@features/invoices/utils/isCompanyCountryId'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

const missingCompanyIdErrorTKeyByCountry: Record<CompanyCountryId, string> = {
  DE: 'external_invoices.missing_company_compliance_details.modal.form.field.registration_no_and_vat_no.org_DE.error.required',
  FR: 'external_invoices.missing_company_compliance_details.modal.form.field.registration_no_and_vat_no.org_FR.error.required',
  NL: 'external_invoices.missing_company_compliance_details.modal.form.field.registration_no_and_vat_no.org_NL.error.required',
  DK: 'external_invoices.missing_company_compliance_details.modal.form.field.registration_no_and_vat_no.org_DK.error.required',
}

export const getMissingCompanyIdErrorMessage = (
  countryId: Organization['countryId'] | undefined,
  t: TFunction,
): string => {
  if (!countryId || !isCompanyCountryId(countryId)) {
    return ''
  }

  return t(missingCompanyIdErrorTKeyByCountry[countryId])
}
